var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 49,
    viewBox: "0 0 54 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8563 42H6.07895L22.8158 28L28.06 32.3867C29.7895 30.1 32.1884 28.2333 35.0895 27.0667L39.5526 23.3333V25.8767C40.4732 25.76 41.3937 25.6667 42.3421 25.6667C43.2905 25.6667 44.2111 25.76 45.1316 25.8767V14L28.3947 0H6.07895C2.98263 0 0.5 2.07667 0.5 4.66667V42C0.5 43.2377 1.08778 44.4247 2.13404 45.2998C3.18029 46.175 4.59932 46.6667 6.07895 46.6667H27.8647C26.8884 45.2433 26.1911 43.68 25.8563 42ZM25.6053 3.5L40.9474 16.3333H25.6053V3.5ZM11.6579 16.3333C13.1375 16.3333 14.5566 16.825 15.6028 17.7002C16.6491 18.5753 17.2368 19.7623 17.2368 21C17.2368 22.2377 16.6491 23.4247 15.6028 24.2998C14.5566 25.175 13.1375 25.6667 11.6579 25.6667C8.56158 25.6667 6.07895 23.59 6.07895 21C6.07895 18.41 8.58947 16.3333 11.6579 16.3333ZM45.1316 30.3333V37.3333H53.5V42H45.1316V49H39.5526V42H31.1842V37.3333H39.5526V30.3333H45.1316Z",
    fill: "#047DE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddImg);
export default __webpack_public_path__ + "static/media/IconAddIMG.d9c35aee01710e66514a43b4dd48a898.svg";
export { ForwardRef as ReactComponent };